<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="title"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    width="700px"
  >
    <div v-show="step===1">
      <el-form label-width="100px" label-position="left" inline>
        <el-form-item :label="$t('Menu.CompanyCode')">
          <el-input v-model="tenantForm.code" style="width: 200px" />
        </el-form-item>
        <el-form-item :label="$t('Menu.CompanyName')">
          <el-input v-model="tenantForm.name" style="width: 200px" />
        </el-form-item>
        <br>
        <el-form-item :label="$t('Menu.CompanyEMail')">
          <el-input v-model="tenantForm.email" style="width: 200px" />
        </el-form-item>
        <el-form-item :label="$t('Menu.CompanyPhone')">
          <el-input v-model="tenantForm.phone" style="width: 200px" />
        </el-form-item>
        <br>
        <el-form-item :label="$t('Menu.CompanyFax')">
          <el-input v-model="tenantForm.fax" style="width: 200px" />
        </el-form-item>
        <el-form-item :label="$t('Menu.GroupCompany')">
          <el-checkbox v-model="tenantForm.groupCompany" style="width: 200px" />
        </el-form-item>
        <br>
        <el-form-item :label="$t('Menu.CompanyAddress')">
          <el-input v-model="tenantForm.address" type="textarea" :rows="3" style="width: 500px" />
        </el-form-item>
        <br>
        <el-form-item v-if="isShowAdmin" :label="$t('Menu.AdminChineseName')">
          <el-input v-model="tenantForm.userName" :disabled="!userNameEnabled" style="width: 200px" />
        </el-form-item>
        <el-form-item v-if="isShowAdmin" :label="$t('Menu.AdminEnglishName')">
          <el-input v-model="tenantForm.userEngligshName" :disabled="!userEngligshNameEnabled" style="width: 200px" />
        </el-form-item>
        <el-form-item v-if="isShowAdmin" :label="$t('Menu.email')">
          <el-input v-model="tenantForm.userEmail" :disabled="!userEmailEnabled" style="width: 200px" />
        </el-form-item>
        <el-form-item v-if="isShowAdmin" :label="$t('Menu.phone')">
          <el-input v-model="tenantForm.userPhone" :disabled="!userPhoneEnabled" style="width: 200px" />
        </el-form-item>
      </el-form>
    </div>
    <div v-show="step===2" style="height: 200px">
      <el-form>
        <br>
        <br>
        <br>
        <br>
        <el-form-item style="text-align: center;">
          <span style="font-size: 20px;color: red;">{{ $t('Menu.Current') }} : {{ tenantForm.id }}</span>
        </el-form-item>
        <center>
          <div>
            <el-form-item>
              <span>{{ $t('Menu.StandardLibrary') }}</span>
              <cargo-advance-select
                ref="tenantSel"
                :select-type="selectTypeNames.TENANT"
                :cache="false"
                filterable
                :custom-label="companyLabel"
                :callback-params="{key:'relateTenantId'}"
                callback-method-type="value"
                :default-value="cboTenantId?cboTenantId:''"
                :static-options="standardList"
                style="width:200px;display: inline-block;margin-left: 10px"
                @parentCallBack="tenantIdChangeHandler"
              />
            </el-form-item>
          </div>
        </center>
      </el-form>
    </div>
    <div v-show="step===3">
      <init-data-group :obj="initDatagroupObj" />
    </div>
    <div v-show="step===4" class="section grid-wrapper">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="menus"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <div slot="footer">
      <el-button v-show="step!==1" type="primary" @click="backStep1Handler">{{ $t('Menu.Back') }}</el-button>
      <el-button type="primary" @click="saveClickHandler">{{ isShowAdmin ? $t('Menu.Next') : $t('Menu.Save') }}</el-button>
      <el-button type="primary" @click="closeHandler">{{ $t('Menu.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import StrUtils from '@/utils/StrUtils'
import { getLoading } from '@/utils/utilBaseElement'
import * as initalDataApi from '@/api/sysManage/baseConfig/initalData'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import InitDataGroup from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/InitDataGroup'
import * as customerApi from '@/api/partner/customer'
import * as menuApi from '@/api/menu'
import * as sysMenuApi from '@/api/menu'

export default {
  name: 'TenantWindow',
  components: { cargoAdvanceSelect, InitDataGroup },
  props: {
    visible: { type: Boolean, required: true },
    isShowAdmin: { type: Boolean, required: true },
    tenant: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      step: 1,
      tenantForm: {
        code: '',
        name: '',
        email: '',
        phone: '',
        fax: '',
        groupCompany: '',
        address: '',
        userName: '',
        userEngligshName: '',
        userEmail: '',
        userPhone: ''
      },
      cboTenantId: '',
      copyTenantKey: '',
      userNameEnabled: true,
      userEngligshNameEnabled: true,
      userEmailEnabled: true,
      userPhoneEnabled: true,
      initDatagroupObj: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        treeData: true,
        rowHeight: 0,
        groupDefaultExpanded: 0,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: '',
          field: 'chineseLabel',
          width: 600,
          headerCheckboxSelection: false
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [],
      menus: [],
      standardList: []
    }
  },
  computed: {
    title() {
      switch (this.step) {
        case 1:
          return this.$t('Menu.InitializeCustomer')
        case 2:
          return this.$t('Menu.copy')
        case 3:
          return this.$t('Menu.InitializeData')
        case 4:
          return this.$t('Menu.InitializeMenu')
        default:
          return ''
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (newVal) {
        Object.assign(this.tenantForm, this.tenant)
        if (this.standardList.length === 0) {
          initalDataApi.findStandardAll().then(resp => {
            const rowData = resp.data.tenants
            rowData.forEach(row => { row.id = row.tenantId })
            this.standardList = rowData
          })
        }
      } else {
        this.reSetForm()
      }
    }
  },
  methods: {
    companyLabel(data) {
      if (data) {
        return '[' + data.id + ']' + data.name
      }
      return ''
    },
    tenantIdChangeHandler(item) {
      this.cboTenantId = item.value
      if (this.cboTenantId) {
        const tenant = this.$refs.tenantSel.options.find(el => el.id === this.cboTenantId)
        if (tenant) {
          this.copyTenantKey = tenant.uuid
        }
      }
    },
    backStep1Handler() {
      if (this.step === 4) {
        this.step = 3
      } else if (this.step === 3) {
        this.step = 2
      } else if (this.step === 2) {
        this.step = 1
        this.userNameEnabled = false
        this.userEngligshNameEnabled = false
        this.userEmailEnabled = false
        this.userPhoneEnabled = false
      }
    },
    saveClickHandler() {
      switch (this.step) {
        case 1:
          this.saveTenant()
          break
        case 2:
          this.saveBasicHandler()
          break
        case 3:
          this.saveMenu()
          break
        case 4:
          this.nextMenu()
      }
    },
    saveTenant() {
      if (!this.tenantForm.name) {
        this.$message.warning(this.$t('Menu.CompanyNamePrompt'))
        return
      }
      if (this.isShowAdmin) {
        if (!this.tenantForm.userEmail) {
          this.$message.warning(this.$t('Menu.mailbox'))
          return
        }
      }
      const tenant = {}
      tenant.uuid = this.tenantForm.uuid ? this.tenantForm.uuid : ''
      tenant.code = this.tenantForm.code
      tenant.name = this.tenantForm.name
      tenant.email = this.tenantForm.email
      tenant.phone = this.tenantForm.phone
      tenant.fax = this.tenantForm.fax
      tenant.groupCompany = this.tenantForm.groupCompany
      tenant.address = this.tenantForm.address
      if (this.isShowAdmin) {
        tenant.userName = this.tenantForm.userName
        tenant.userEligshName = this.tenantForm.userEligshName
        tenant.userEmail = this.tenantForm.userEmail
        tenant.userPhone = this.tenantForm.userPhone
      }
      const loading = getLoading()
      customerApi.saveTenant(tenant).then(resp => {
        this.saveResult(resp)
      }).finally(() => loading.close())
    },
    saveResult(resp) {
      if (this.isShowAdmin) {
        Object.assign(this.tenantForm, resp.data)
        this.step = 2
      } else {
        this.$message.success(this.$t('Menu.UpdateSuccess'))
        this.$emit('successCallBack')
        this.closeHandler()
      }
    },
    async saveBasicHandler() {
      if (this.cboTenantId) {
        const params = {}
        params.tenantId = Number(this.tenantForm.id)
        params.copyTenantId = Number(this.cboTenantId)
        await initalDataApi.createInitalData(params).then(resp => {
          this.result(resp)
        })
      } else {
        this.$message.warning(this.$t('Menu.copyTenantId'))
      }
    },
    async result(resp) {
      await initalDataApi.updateInitalData(resp.data).then(res => {
        this.saveBasicResult(res)
      })
    },
    saveBasicResult(resp) {
      this.step = 3
      this.initDatagroupObj = resp.data
    },
    saveMenu() {
      const params = {}
      params.tenantKey = this.tenantForm.uuid
      params.copyTenantKey = this.copyTenantKey
      const loading = getLoading()
      menuApi.initMenu(params).then(resp => {
        this.saveMenuResult()
      }).finally(() => loading.close())
    },
    saveMenuResult() {
      this.step = 4
      this.queryTenantMenus()
    },
    nextMenu() {
      this.$message.success(this.$t('Menu.Initialized'))
      this.closeHandler()
    },
    closeHandler() {
      this.step = 1
      this.tenantForm.userName = ''
      this.tenantForm.userEligshName = ''
      this.tenantForm.userEmail = ''
      this.tenantForm.userPhone = ''
      this.userNameEnabled = true
      this.userEngligshNameEnabled = true
      this.userEmailEnabled = true
      this.userPhoneEnabled = true
      this.$emit('close')
    },
    reSetForm() {
      this.form = {
        chineseLabel: '',
        englishLabel: '',
        code: '',
        icon: '',
        actions: '',
        url: '',
        parentId: 0,
        orderIndex: 1,
        type: 2
      }
    },
    queryTenantMenus() {
      sysMenuApi.queryTenantMenuList(this.tenantForm.uuid).then(resp => {
        const rowData = resp.data
        this.addTreePath(rowData)
        this.menus = rowData
      })
    },
    // 添加树形路径
    addTreePath(menus, menu) {
      const map = new Map()
      menus.forEach(menu => map.set(menu.menuId, menu.uuid))
      // menu有值时，为新增/编辑后的额外处理start
      if (menu) {
        // 已有数据 编辑的
        if (map.has(menu.menuId)) {
          const index = menus.findIndex(m => m.menuId === menu.menuId)
          menus[index] = menu
        } else {
          // 新增的
          menus.push(menu)
        }
      }
      // menu有值时的处理end
      menus.forEach(menu => {
        if (!menu.parentId) {
          menu.path = menu.uuid
        } else {
          menu.path = map.get(menu.parentId) + ',' + menu.uuid
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
